import { configureStore } from "@reduxjs/toolkit";
import { reducer } from "../AppSettings";

export const store = configureStore({ reducer });
export type _Store = ReturnType<typeof store.getState>;
